// @flow
import styled, { css } from "styled-components"
import StyledLink from "components/StyledLink"

export const SidebarWrap = styled.div`
  position: fixed;
  top: 0;
  right: 100%;
  width: 24rem;
  height: 100vh;
  transition: transform 0.25s ease;
  background: ${(props) => props.theme.color.white};
  min-height: 100%;
  padding: 3.2rem 7rem 4rem 4rem;

  ${p =>
    p.isOpen &&
    css`
      transform: translateX(100%);
    `}
`

export const LogoWrap = styled.div`
  margin-bottom: 2rem;
`

export const Link = styled(StyledLink)`
  display: block;
  width: 100%;
  font-size: 1.5rem;
  text-transform: uppercase;
  font-weight: ${(props) => props.theme.fontWeights.book};
  text-align: left;
  border: 0;
  color: ${(props) => props.theme.color.primaryText};
  margin-bottom: 1.5rem;

  &.active {
    opacity: 0.5;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/Hamburger/Sidebar/styled.js